import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Features/auth/authSlice";
import campaignReducer from "./Features/campaign/campaignSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    campaign: campaignReducer,
  },
});

export default store;
